import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import CaseHistoryTimeline from "../components/CaseHistoryModule/CaseHistoryTimeline";
import CaseForm from "../components/CaseModule/CaseForm";
import AppGlobalStaticData from "../appdata/appStaticData";
import useCourtAPIDetails from "../api/courtAPIDetails";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
} from "@mui/material";

import AutohideSnackbar from "../components/LayoutModule/autohideSnackbar";
import useCaseAPIDetails from "../api/caseAPIDetails";

const CaseHistoryPage = () => {
  const [open, setOpen] = useState(false);
  const { getCaseDetails } = useCaseAPIDetails();
  const [selectedcaseId, setSelectedcaseId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbarProperties, setSnackbarProperties] = useState({
    duration: 0,
    message: "",
    serverity: "",
  });
  const { courtList, fetchCourtsList } = useCourtAPIDetails();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  useEffect(() => {
    if (snackbarProperties.message) {
      setSnackbarOpen(true);
    }
  }, [snackbarProperties.message]);

  const [cases, setCases] = useState({
    fileNo: "",
    caseNo: "",
    IANo: "",
    CNRNo: "",
    clientName: "",
    appearingFor: "",
    mobile: "",
    mobile2: "",
    prevDate: "",
    nextDate: "",
    status: "",
    courtID: 0,
    caseStatus: 0,
  });

  const Type = "List";
  const caseStatusList = [
    { id: 0, name: "select" },
    { id: 1, name: "Disposed" },
    { id: 2, name: "Decreed" },
  ];

  const globalData = new AppGlobalStaticData();
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    const token = Cookies.get("auth_token");
    if (!token) {
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  }, [navigate]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarProperties({
      duration: 0,
      message: "",
      serverity: "",
    });
  };

  useEffect(() => {
    // fetech case details and case History Infomation.
    setLoading(true);
    if (id) {
      if (courtList.length == 0) {
        fetchCourts();
      }
      caseDetails(); // load case details 
    }
  }, [id]);

  const caseDetails =() =>{
    getCaseDetails(id, "")
        .then((caseData) => {
          if (!caseData) {
            setSnackbarProperties({
              duration: globalData.Duration,
              message: globalData.FetchCaseFailed,
              severity: globalData.SeverityError,
            });
            console.error("Failed to fetch case details");
          } else {
            setCases({
              ...caseData,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching case details:", error);
        })
        .finally(() => {
          setLoading(false);
        });
  }
  const handleEditCase = () => {
    setOpen(true);
    setSelectedcaseId(id);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedcaseId(null);
    caseDetails(); // load case details 
  };

  // const handleEditHistory = (index) => {
  //   const newDetails = prompt("Edit case history:", historyData[index].details);
  //   if (newDetails !== null) {
  //     setHistoryData((prev) =>
  //       prev.map((item, i) =>
  //         i === index ? { ...item, details: newDetails } : item
  //       )
  //     );
  //   }
  // };

  // const handleAddHistory = () => {
  //   const newEntry = prompt("Enter new case history:");
  //   if (newEntry) {
  //     setHistoryData((prev) => [
  //       {
  //         details: newEntry,
  //         updatedBy: "Admin",
  //         updatedDate: new Date().toISOString(),
  //       },
  //       ...prev,
  //     ]);
  //   }
  // };

  const fetchCourts = async () => {
    await fetchCourtsList().then((courtList) => {
      if (!courtList || courtList.length == 0) {
        setSnackbarProperties({
          duration: globalData.Duration,
          message: globalData.CourtListFailed,
          serverity: globalData.SeverityError,
        });
      }
    });
  };

  if (loading || courtList.length == 0) {
    return <CircularProgress />;
  }

  return (
    <div>
      <CaseHistoryTimeline
        courtList={courtList}
        caseDetails={cases}
        onEditCase={handleEditCase}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedcaseId ? "Edit Case" : "Create Case"}
        </DialogTitle>
        <DialogContent>
          <CaseForm
            id={selectedcaseId}
            onClose={handleClose}
            Type={Type}
            caseStatusList={caseStatusList}
          />
        </DialogContent>
      </Dialog>

      <AutohideSnackbar
        open={snackbarOpen}
        duration={snackbarProperties.duration}
        message={snackbarProperties.message}
        severity={snackbarProperties.serverity}
        handleClose={handleSnackbarClose}
      ></AutohideSnackbar>
    </div>
  );
};

export default CaseHistoryPage;
